import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_inkind_benefits_voluntary'

export const dataPointDefinition = {
  retracedId: 'are_all_inkind_benefits_voluntary',
  name: 'Are all in-kind benefits voluntary?',
  description:
    'The intent of this question is to understand if in-kind benefits are always voluntary. Meaning, can workers "opt-out" of them if they would like to. \r\r\n\r\r\nIf workers cannot "opt-out" of in-kind benefits, the answer selection should be "NO". \r\r\n\r\r\nFor example, if workers cannot "opt-out" of the facility-operated housing (provided for free or at a subsidized rate), answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-22--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9590,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
